import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';
import { API_NAMES, initApi } from "@usas/ui-web/utils/HttpApiHelper";

const getLTSVoucherCityData = (learnToSwimVoucherCityVoucherId, state, setState) => {
  if (learnToSwimVoucherCityVoucherId) {
    const api = initApi(API_NAMES.COMMON, state, setState);
    const url = `/LearnToSwimParticipant/info/${learnToSwimVoucherCityVoucherId}`;

    return api?.executeArray ? api.executeArray(url, 'GET') : null;
  }
};

const LearnToSwimVoucherData = { 
  INITIAL_STATE: BASIC_INITIAL_STATE, 
  getLTSVoucherCityData };

export default LearnToSwimVoucherData;
